import Repository from './Repository'

const resource = 'history-horse-rider'

export default {
  updateHistoryHorseRider (tenantId, historyId, data) {
    return Repository.patch(`tenants/${tenantId}/${resource}/${historyId}`, data)
  }
}
